/**
 * AP-37 Nachtrag 7 (N7-5) — **Ablage der Arbeitsschritte** eines Kalkulationsblatts.
 *
 * Wie bei den Arbeitsschritten des Projekts (AP-35 Nachtrag 10): Kopiert werden nur die Kennungen, gemerkt im
 * Browser; das Einfügen holt die Schritte am Server und kopiert sie in das Blatt. So überlebt die Ablage den
 * Wechsel der Position, der Kalkulation und das Neuladen — und sie gilt nur für den, der kopiert hat.
 *
 * Eine eigene Ablage, nicht die der Positionen und Artikelzeilen: Ein Arbeitsschritt ist keine Zeile, die ein
 * Beleg oder eine Stückliste aufnehmen könnte.
 */
export interface SchrittAblage {
  userId: string
  stepIds: string[]
  /** „K0142-26 · Pos. 3“ — woher die Schritte kopiert sind. */
  herkunft: string
}

const ABLAGE = 'symphenia-kalkulation-schritte-ablage'
const EREIGNIS = 'symphenia-kalkulation-schritte-ablage'

export function leseSchrittAblage(userId: string | undefined): SchrittAblage | null {
  try {
    const roh = JSON.parse(localStorage.getItem(ABLAGE) ?? 'null') as SchrittAblage | null
    return roh && roh.userId === userId && Array.isArray(roh.stepIds) && roh.stepIds.length > 0 && roh.stepIds.every((id) => typeof id === 'string') ? roh : null
  } catch {
    return null
  }
}

export function schreibeSchrittAblage(ablage: SchrittAblage | null): void {
  try {
    if (ablage) localStorage.setItem(ABLAGE, JSON.stringify(ablage))
    else localStorage.removeItem(ABLAGE)
  } catch {
    // ohne Speicher keine Ablage über das Neuladen hinaus
  }
  window.dispatchEvent(new Event(EREIGNIS))
}

/** Meldet Änderungen der Ablage — auch aus einem anderen Tab (`storage`). */
export function beobachteSchrittAblage(rueckruf: () => void): () => void {
  const aufStorage = (e: StorageEvent) => e.key === ABLAGE && rueckruf()
  window.addEventListener(EREIGNIS, rueckruf)
  window.addEventListener('storage', aufStorage)
  return () => {
    window.removeEventListener(EREIGNIS, rueckruf)
    window.removeEventListener('storage', aufStorage)
  }
}
